import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ResetPasswordDialogComponent } from "../reset-password-dialog/reset-password-dialog.component";

@Component({
  selector: "app-login-dialog",
  templateUrl: "./login-dialog.component.html",
  styleUrls: ["./login-dialog.component.scss"],
})
export class LoginDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    private dialog: MatDialog,
    private router: Router
  ) {}

  /**
   * Opens the Forgot Password modal if the link is reset-password.
   */
  ngOnInit(): void {
    const urlTree = this.router.parseUrl(this.router.url);

    if (urlTree.root.children["primary"]?.segments.map((s) => s.path).join("/") === "reset-password") {
      const token = urlTree.queryParams["token"];

      this.onForgotPassword(token);
    }
  }

  /**
   * Closes dialog after successful login
   * @param event Indicates if login succeeded
   */
  public loginFormSubmit(event: boolean): void {
    if (event) {
      this.dialogRef.close(true);
    }
  }

  /**
   * Closes dialog after logout action
   */
  public logoutClick(): void {
    this.dialogRef.close(false);
  }

  /**
   * Opens reset password dialog
   * @param code Reset code
   */
  public onForgotPassword(code?: string): void {
    this.dialog.open(ResetPasswordDialogComponent, {
      disableClose: true,
      data: {
        code,
      },
    });
  }
}
